import React, { useState } from 'react'

import { Button, Text, TextLink, Form, TextArea, FormControl, Checkbox, Dropdown, HeadingAndText, Stack } from 'glic-ui-components'
import ImpContact from './ImpContact';
import Textbox from './Textbox';
import CheckBoxField from './CheckBoxField';
import TextAreafield from './TextAreafield';
import TextField from '../TextField';
import "../styles/styles.css"

const GForm = () => {

    const gotoFindProvider = (e) => {
        e.preventDefault();
        window.open("https://www.guardiananytime.com/fpapp/search",
            "_blank", "width=900, -00height=600");
    }
    const initialformstate = {
        PatientNumber: "",
        GroupNumber: "",
        GroupName: "",
        EmployeeName: "",
        PatientName: "",
        DentalOfficeName: "",
        DentalOfficeNumber: "",
        Description: "",
        email: "",
        Phone1: "",
        BestTimeToContact: "",

    }
    const [previewdetails, setPreviewdetails] = useState(false);
    const [formData, setFormData] = useState(initialformstate);
    const [checkbox, setCheckbox] = useState(false);
    const [emailChecked, setEmailChecked] = useState(false);
    const [phoneChecked, setPhoneChecked] = useState(false);
    const [bestTimeContact, setbestTimeContact] = useState('');
    const [isEmergencychecked, setisEmergencychecked] = useState(false);
    const [issubmited, setissubmited] = useState(false);
    const [isCDXError, setCDXError] = useState(false);

    const [errors, setErrors] = useState({
        GroupName: "",
        PatientName: ""
    });

    const validateReqFields = (e) => {
        if (e?.target?.value.trim() === "") {
            return e?.target?.id + " Field is required";
        }
        else {
            return ";"
        }
    }

    const handleContactcheckbox = (e, items, formdata) => {
        // console.log(items.ischecked, e, "yu")
        // console.log(formdata, "data")
        if (e?.target?.id === 'Email') {
            setEmailChecked(e?.target?.checked);
        }
        if (e?.target?.id === 'Phone') {
            setPhoneChecked(e?.target?.checked);
        }
        // console.log(phoneChecked)

        if (formData.email != true && formData.email) {
            // console.log("plese provide checkbox details")
        }


    }

    const handleEmergency = (e) => {
        setisEmergencychecked(e.target.checked);
        setFormData({ ...formData, EmergencyCare: e.target.checked })
        // console.log(e.target.checked, "emer")
    }
    const handledropdownchange = (newValue) => {

        setbestTimeContact(newValue.value);
        // console.log(newValue.value);
        setFormData({ ...formData, BestTimeToContact: newValue.value })
        // console.log(newValue.value, "BestTimeToContact");
    }

    const handleValidation = (result, onSubmit, validationResult, onSubmitEvent, formData) => {
        // console.log(validationResult, "pass")
        // console.log(result, "valid")
        if (result.isFormValid === true) {
            // console.log("validation passed")
            setPreviewdetails(true);

        }
        else {
            setPreviewdetails(false);
            // console.log(validationResult.isFormValid, "fail")
            // console.log(validationResult, 'er');
            // console.log(onSubmitEvent, 'jk');
            // console.log(formData);
        }

    }

    const OnChange = (e) => {
        // console.log(e, "fg")
        setCheckbox(false);
        const { name, value, type, checked } = e.target;
        // console.log(name, value);
        setFormData({ ...formData, [name]: value })
        // setFormData((prevData)=>({
        //     ...prevData,
        //     [name]:value,
        // }));
    }
    // console.log(formData)
    const PreviewData = () => {


    }
    const NavigateToForm = (newValue) => {
        // history.push("/GrievanceForm");
        // setFormData(initialformstate);
        // setEmailChecked(false);
        // setPhoneChecked(false);
        // setisEmergencychecked(false);

        // setbestTimeContact(newValue.value);
        setFormData({ ...formData, BestTimeToContact: newValue.value })
        // console.log(formData.BestTimeToContact);


        setPreviewdetails(false);

    }
    const handleEmail = async () => {
        setPreviewdetails(true);
        // sendemail(formData);
        // console.log(formData);
        try {
            const response = await fetch('/GrievanceForm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    formData: {
                        PatientNumber: formData.PatientNumber,
                        GroupNumber: formData.GroupNumber,
                        GroupName: formData.GroupName,
                        EmployeeName: formData.EmployeeName,
                        PatientName: formData.PatientName,
                        DentalOfficeName: formData.DentalOfficeName,
                        DentalOfficeNumber: formData.DentalOfficeNumber,
                        Description: formData.Description,
                        EmergencyCare: isEmergencychecked ? 'Yes' : 'No',
                        Email: formData.email,
                        Phone: formData.Phone1,
                        BestTimeToContact: bestTimeContact
                    },
                }),
            })

            if (response.ok) {
                console.log('Email sent successfully!', response);
                setissubmited(true)
            }
            else {
                console.log('Failed to send Email!', await response.json());
                setCDXError(true)
            }
            // console.log("Failed",response);
        }
        catch (error) {
            console.log('Error while sending Email!:', error);
            setCDXError(true)
        }


    };



    return (
        <>
            <div className="container">
                <div className="table custom-bg-gray">
                    <div className="row">

                        <div className='col-md-8'>
                            {
                                isCDXError ? (
                                    <div>
                                        <HeadingAndText
                                            heading="Thank you "
                                            headingTag="h2"
                                            headingStyle="large"
                                            text="We are experiencing technical issues with your submission process. Please try again later or contact us for help.  We apologize for the inconvenience."
                                            textStyle="bodyLg"
                                            textColor="HudsonNavy"
                                            width="fluid"
                                        />
                                    </div>) :
                                    issubmited ? (
                                        <div>
                                            <HeadingAndText
                                                heading="Thank you "
                                                headingTag="h2"
                                                headingStyle="large"
                                                text="Thank you for taking the time to share this information with us. Your feedback is important and we will treat it with the professional service you deserve. You will be hearing from a Managed Dental Care representative shortly."
                                                textStyle="bodyLg"
                                                textColor="HudsonNavy"
                                                width="fluid"
                                            />
                                        </div>
                                    ) : previewdetails ? (
                                        <div>

                                            <div className="row">
                                                <div className='col-md-12'>
                                                    <h2 className="formLabel text-header"
                                                        color="HudsonNavy">
                                                        Please review your responses
                                                    </h2>
                                                    <Text bodyMd>
                                                        If you need to make any changes, click the Back button to return to the form. If you are satisfied that your form is ready to send, click the Submit button.                                </Text>
                                                </div>
                                            </div>
                                            <h2 className="formLabel text-header">Patient Information</h2>
                                            <p>Patient Number: {formData?.PatientNumber}</p>
                                            <p>Group Number: {formData?.GroupNumber}</p>
                                            <p>Group Name: {formData?.GroupName}</p>
                                            <p>Employee Name: {formData?.EmployeeName}</p>
                                            <p>Patient Name: {formData?.PatientName}</p>
                                            <p>Dental Office Name: {formData?.DentalOfficeName}</p>
                                            <p>Dental Office Number: {formData?.DentalOfficeNumber}</p>
                                            <p>Description Of Situation: {formData?.Description}</p>
                                            <p>Emergency Care : {isEmergencychecked ? "Yes" : "No"}</p>
                                            <h2 className="formLabel text-header">Contact Information</h2>
                                            <p>Email: {formData?.email}</p>
                                            <p>Phone: {formData?.Phone1}</p>
                                            <p>Best Time to Contact: {bestTimeContact}</p>

                                            <Stack direction="horizontal" vAlign="center" spacing={64}>
                                                <Button id="fv-btn-submit" type="primary" buttonType="submit" size="large"

                                                    onClick={NavigateToForm}
                                                >Back</Button>
                                                <Button id="fv-btn-reset" type="secondary" buttonType="reset" size="large"
                                                    onClick={handleEmail}
                                                >Submit</Button>
                                            </Stack>

                                        </div>
                                    ) : (
                                        <><div className="row">
                                            <div className='col-md-12'>
                                                <h2 className="formLabel text-header"
                                                    color="HudsonNavy" >
                                                    Please Provide the Following Information
                                                </h2>
                                                <Text bodyMd>
                                                    We regret any trouble you may have experienced. We encourage you to provide as much detail as you like. Rest assured that your information is transmitted using a secure connection.<br /> All required fields are marked with an asterisk (*).
                                                </Text>
                                            </div>
                                        </div><div className="row">
                                                <div className='col-md-12'>
                                                    <h2 className="formLabel text-header"
                                                        color="HudsonNavy">
                                                        Patient Information
                                                    </h2>
                                                    <Text bodyMd>
                                                        Though they are not required, please help us address your grievance faster by providing the Patient Number and Group Number.
                                                    </Text>
                                                </div>
                                            </div><Form id="form-validation"
                                                onSubmit={((result, onSubmit, validationResult, onSubmitEvent, formData) =>
                                                    handleValidation(result, 'Form onSubmit: ', validationResult, onSubmitEvent, formData))}
                                                validateOnSubmit
                                            >

                                                <div className="row mb-3">
                                                    <div className='col-md-6'>
                                                        <Textbox value={formData.PatientNumber} onTextChange={OnChange} Id="PatientNumber" title="Patient Number" required={false} type="text" ></Textbox>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <Textbox value={formData?.GroupNumber} onTextChange={OnChange} Id="GroupNumber" title="Group Number" required={false} type="text" ></Textbox>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className='col-md-6'>
                                                        <label id="group-name-label" className="sr-only">Group Name, required field</label>
                                                        <Textbox value={formData?.GroupName} onTextChange={OnChange} Id="GroupName" title="Group Name *" required={true} type="text" width="100" isDisabled={false} ariaLabelledby="group-name-label" labelName="Group Name" ariDescBy="GroupName-error-message"></Textbox>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label id="emp-name-label" className="sr-only">Employee Name, required field</label>
                                                        <Textbox value={formData?.EmployeeName} onTextChange={OnChange} Id="EmployeeName" title="Employee Name *" required={true} type="text" width="100" isDisabled={false} ariaLabelledby="emp-name-label" labelName="Employee Name" ariDescBy="EmployeeName-error-message"></Textbox>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className='col-md-6'>
                                                        <label id="patient-name-label" className="sr-only">Patient Name, required field</label>
                                                        <Textbox value={formData?.PatientName} onTextChange={OnChange} Id="PatientName" title="Patient Name *" required={true} type="text" width="100" isDisabled={false} ariaLabelledby="patient-name-label" labelName="Patient Name" ariDescBy="PatientName-error-message"></Textbox>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label id="dental-office-name-label" className="sr-only">Dental office Name, required field</label>
                                                        <Textbox value={formData?.DentalOfficeName} onTextChange={OnChange} Id="DentalOfficeName" title="Dental Office Name *" required={true} type="text" width="100" isDisabled={false} ariaLabelledby="dental-office-name-label" labelName="Dental Office Name" ariDescBy="DentalOfficeName-error-message"></Textbox>
                                                    </div>
                                                </div>
                                                <div className='row mb-3'>
                                                    <div className='col-md-6'>
                                                        <Textbox value={formData?.DentalOfficeNumber} onTextChange={OnChange} Id="DentalOfficeNumber" title="Dental Office Number" required={false} type="text" width="100" isDisabled={false} ></Textbox>
                                                    </div>
                                                </div>
                                                <div className='row mb-3'>
                                                    <div className='col-md-12'>
                                                        <label id="desc-label" className="sr-only">Description, required field</label>
                                                        <TextAreafield
                                                            label="Description *"
                                                            id="Description"
                                                            name="Description"
                                                            required={true}
                                                            value={formData?.Description}
                                                            onTextChange={OnChange}
                                                            isDisabled={false}
                                                            ariaLabelledby="desc-label"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className='col-md-12'>

                                                        <Checkbox
                                                            id="Emergency"
                                                            name="Emergency"
                                                            label="Check here if this grievance involves emergency care."
                                                            // value={formData.EmergencyCare}
                                                            isChecked={formData.EmergencyCare}
                                                            onChange={handleEmergency}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className='col-md-12'>
                                                        <h2 className="formLabel text-header"
                                                            color="HudsonNavy">
                                                            Contact Information *
                                                        </h2>
                                                        <Text bodyMd>
                                                            Please provide at least one method for us to contact you.
                                                        </Text>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className='col-md-3'>
                                                        <CheckBoxField
                                                            id="Email"
                                                            name="Email"
                                                            label="Email"

                                                            required={emailChecked ? false : true}
                                                            checked={emailChecked}
                                                            ariaLabelledby="email-label"
                                                            // onChange={(e, checkboxArray, checkboxItemsArray) => console.log(e, checkboxArray, checkboxItemsArray)}
                                                            onChangeCheck={(e, items, formdata) => handleContactcheckbox(e, items, formData)}
                                                        // onSubmit={handlesubmit}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <TextField value={formData.email} onTextChange={OnChange} isDisabled={emailChecked ? false : true}
                                                            Id="email" name="email" required={emailChecked ? true : false}
                                                            validations={{
                                                                email: { message: 'Please enter a valid email address', regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/ },
                                                                required: { message: 'Email field is required.' },
                                                            }}
                                                            ariaLabelledby="email-label"
                                                            type="email" ></TextField>
                                                        <label id="email-label" className="sr-only"> Email should be in xxx@xxx.xxx format</label>
                                                    </div>

                                                    <div className='col-md-3'>
                                                        <Text bodyMd>
                                                            (xxx@xxx.xxx)
                                                        </Text>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className='col-md-3'>
                                                        <CheckBoxField
                                                            id="Phone"
                                                            name="Phone"
                                                            label="Phone"
                                                            required={(phoneChecked || emailChecked) ? false : true}
                                                            checked={phoneChecked}
                                                            // onChange={(e, checkboxArray, checkboxItemsArray) => console.log(e, checkboxArray, checkboxItemsArray)}
                                                            onChangeCheck={(e, items, formdata) => handleContactcheckbox(e, items, formData)}
                                                        // onSubmit={handlesubmit}

                                                        />
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <TextField value={formData.Phone1} name="Phone1"
                                                            inputMode="numeric"
                                                            onTextChange={OnChange} Id="Phone1"
                                                            validations={{
                                                                regex: { message: 'Please enter a valid phone number', regex: /^\d{10}$/ },
                                                                required: { message: 'Phone field is required.' },
                                                            }}
                                                            ariaLabelledby="phone-label"
                                                            required={phoneChecked ? true : false} type="tel"
                                                            // onChangeCheck={(e) => {if (!/[0-9]/.test(e.checked)){e.preventDefault();}}}
                                                            isDisabled={phoneChecked ? false : true}></TextField>
                                                        <label id="phone-label" className="sr-only"> Phone should be in 999-999-9999 format</label>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <Text bodyMd>
                                                            (999-999-9999)
                                                        </Text>
                                                    </div>
                                                </div>

                                                <div className='row mb-3'>
                                                    <div className='col-md-3'>

                                                    </div>
                                                    <div className='col-md-6'>
                                                        <Dropdown
                                                            id="time"
                                                            name="time"
                                                            label="Best Time to Contact:"
                                                            options={[
                                                                { value: 'Before Noon', text: 'Before Noon' },
                                                                { value: 'Evening', text: 'Evening' },
                                                                { value: 'Early Morning', text: 'Early Morning' },
                                                            ]}
                                                            // onChange={(e) => setFormData({...formData,BestTimeToContact:e.target.value})}
                                                            onChange={(newValue) => handledropdownchange(newValue)}
                                                            selected={bestTimeContact}

                                                            // onClose={(closeValue) => console.log('onClose', closeValue)}
                                                            // onClose={(closeValue) => console.log('onClose', closeValue)}
                                                            placeholder="Select an option" />
                                                    </div>
                                                    <div className='col-md-3'>

                                                    </div>
                                                </div>
                                                <br />
                                                <div>
                                                    <div>

                                                        <Button id="fv-btn-submit" type="primary" buttonType="submit" size="large"

                                                            onClick={(e) => {
                                                                PreviewData();
                                                            }}
                                                        >Preview your Responses</Button>
                                                    </div>
                                                </div>

                                            </Form>
                                        </>
                                    )
                            }
                        </div>
                        <div className='col-md-4'>
                            <ImpContact></ImpContact>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h2 className="formLabel text-header"
                                        color="HudsonNavy">
                                        Helpful Links
                                    </h2>
                                    <ul>
                                        <li>
                                            <TextLink
                                                inlineSize="body-sm"
                                                id="fps"
                                                onClick={gotoFindProvider}  >
                                                Find a Dental Provider
                                            </TextLink></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
            <div>
                <div>
                    <Text bodyMd elementProps={{ textParagraph: { className: 'footer-text-heading' } }}>
                        CALIFORNIA DEPARTMENT OF MANAGED HEALTH CARE DISCLOSURE REGARDING GRIEVANCES:
                    </Text>
                </div>
            </div>
            <div>
                <div className="text-justify">
                    <Text bodyMd elementProps={{ textParagraph: { className: 'footer-text-description' } }}>
                        The California Department of Managed Health Care is responsible for regulating health care service plans. If you have a grievance against your health plan, you should first telephone your health plan at <b>1-800-273- 3330</b> and use your health plan’s grievance process before contacting the department. Utilizing this grievance procedure does not prohibit any potential legal rights or remedies that may be available to you. If you need help with a grievance involving an emergency, a grievance that has not been satisfactorily resolved by your health plan, or a grievance that has remained unresolved for more than 30 days, you may call the department for assistance. You may also be eligible for an Independent Medical Review (IMR). If you are eligible for IMR, the IMR process will provide an impartial review of medical decisions made by a health plan related to the medical necessity of a proposed service or treatment, coverage decisions for treatments that are experimental or investigational in nature and payment disputes for emergency or urgent medical services. The department also has a toll-free telephone number (<b>1-888-446-2219</b>) and a TDD line (<b>1-877-688-9891</b>) for the hearing and speech impaired. The department’s Internet Web site <b>www.dmhc.ca.gov</b> has complaint forms, IMR application forms and instructions online.
                    </Text>
                </div>
            </div>
        </>

    )
}

export default GForm
